import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "assets/icons/search_main.svg";
import { ReactComponent as FiltterIcon } from "assets/icons/organized_filter.svg";
import { ReactComponent as OrganizedPropertiesI } from "assets/icons/info_2.svg";
import { ReactComponent as AddIcon } from "assets/icons/add_icon.svg";
import PropertyFilterDropdown from "components/DropDown/PropertyTypeFilterDropdown";
import useSearch from "hooks/useSearch";
import { useMediaQuery } from "react-responsive";
import { useOrganiseList } from "context/OrganiseListContext";
import InputDialog from "components/Dialog/InputDialog";
import useProperties from "hooks/useProperties";
import { isValidURL } from "utils/commonUtils";
import { toast } from "react-toastify";
import { Tooltip as ReactTooltip } from "react-tooltip";

const OrganizerHeader = ({
  isExternalProperty,
  filterId,
  searchQuery,
  setSearchQuery,
  setOpenCustomExternalPropertyPopup,
}) => {
  const { toggleFilterDropdown } = useSearch();
  const { selectedOrganiseList } = useOrganiseList();
  const { addExternalProperty, isAddingExternal } = useProperties();
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const [isAddPropertyDialogOpen, setIsPropertyDialogOpen] = useState(false);
  const [externalUrl, setExternalUrl] = useState("");
  const [validationError, setValidationError] = useState("");

  // Handle dialog input change
  const handleInputChange = (e) => {
    setExternalUrl(e.target.value);
  };

  // External property add
  const handleAddExternalProperty = async () => {
    const isValid = isValidURL(externalUrl);
    if (!isValid) {
      setValidationError("URL non valido. Riprova");
      setTimeout(() => {
        setValidationError("");
      }, 5000);
      return;
    }
    try {
      await addExternalProperty(externalUrl);
    } catch (error) {
      toast.error(
        "Non siamo riusciti a recuperare le informazioni dal link inserito. Riempi manualmente le informazioni necessarie."
      );
      setOpenCustomExternalPropertyPopup(externalUrl);
    }
    setIsPropertyDialogOpen(false);
    setExternalUrl("");
  };

  return (
    <>
      <div
        style={{
          borderBottom:
            !isMobile && isExternalProperty ? "1px solid #5F5F5F26" : "none",
        }}
        className="lg:h-[106px] pl-4 lg:pl-[33px] pr-4 lg:pr-[17px] relative flex lg:justify-between lg:space-x-5 space-y-[13px] lg:space-y-0 lg:items-center pt-[11px] lg:pt-0 flex-col lg:flex-row"
      >
        <div className="w-full justify-between lg:w-auto flex items-center space-x-[18px]">
          <div className="flex items-center space-x-[13px] sm:space-x-[18px]">
            <div
              style={{ backgroundColor: selectedOrganiseList.color }}
              className="min-w-[48px]  sm:min-w-[52px] h-[48px] sm:h-[52px] grid place-items-center rounded-full text-2xl sm:text-3xl bg-[#45A772]"
            >
              {selectedOrganiseList?.emoji}
            </div>
            <h1 className="text-black text-[16px] sm:text-[22px] font-bold leading-[19.36px] sm:leading-[30px]">
              {selectedOrganiseList?.name}
            </h1>
          </div>
          <div>
            <span
              data-tooltip-id="organize_property_tooltip"
              data-tooltip-content={
                isExternalProperty
                  ? "Qui verranno mostrate tutte le proprietà aggiunte da link esterni o dall’estensione chrome"
                  : "Qui verranno mostrate tutte le proprietà salvate nella ricerca di HouseScan"
              }
            >
              <OrganizedPropertiesI className="cursor-pointer" />
            </span>
            {/* Info Tooltip  */}
            <ReactTooltip
              id="organize_property_tooltip"
              place="top"
              positionStrategy="fixed"
              className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
            />
          </div>
        </div>
        <div className="flex lg:flex-1 lg:justify-end items-center sm:space-x-[11px]">
          {isExternalProperty && (
            <div
              onClick={() => setIsPropertyDialogOpen(true)}
              className="bg-primary hidden h-[50px] rounded-[10px] cursor-pointer flex-shrink-0 w-[215px] sm:inline-flex items-center pl-[19px] space-x-[29px]"
            >
              <div className="w-[26px] h-[26px] rounded-full grid place-content-center bg-white text-primary text-2xl">
                <AddIcon />
              </div>
              <p className="text-[#F2F2F2] text-[20px] font-semibold">
                Aggiungi
              </p>
            </div>
          )}
          <div className="h-[50px] w-full  xl:w-[450px] 2xl:w-[532px] rounded-[10px] border border-[#C5C5C5] pl-[26px] pr-[18px] flex justify-between items-center space-x-3">
            <div className="flex-1 flex items-center space-x-[9px]">
              <SearchIcon />
              <input
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Cerca per Nome"
                className="outline-none border-none w-full bg-transparent text-[12px] placeholder:text-[#4F6F8F] font-normal"
              />
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="cursor-pointer"
            >
              <FiltterIcon />
            </div>
          </div>
        </div>
      </div>
      <InputDialog
        label="Aggiungi proprietà alla lista"
        placeholder="url"
        buttonText="Aggiungi Proprietà"
        validationError={validationError}
        value={externalUrl}
        loading={isAddingExternal}
        onChange={handleInputChange}
        isOpen={isAddPropertyDialogOpen}
        isClose={() => setIsPropertyDialogOpen(false)}
        onClick={handleAddExternalProperty}
      />
    </>
  );
};

export default OrganizerHeader;
